import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Input, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { RouterLink } from '@angular/router';
import { GlobalService } from '../../services/global.service';
import { LocalCacheService } from '../../services/localCache.service';
import { environment } from '../../../environments/environment';
import { PDSService } from '../../services/pds.service';

@Component({
  selector: 'app-common-header',
  standalone: true,
  imports: [RouterLink, CommonModule],
  templateUrl: './common-header.component.html',
  styleUrl: './common-header.component.scss',
})
export class CommonHeaderComponent implements OnInit {
  @Input() activeHeader: string = '';
  agentName: string = '';
  isPASUser: boolean = false;
  PASUrl: string = '';
  partnerCode: string = '';

  constructor(
    private globalService: GlobalService,
    private localCacheService: LocalCacheService,
    public pdsService: PDSService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.PASUrl = environment.PASUrl;
  }
  ngOnInit(): void {
    var agentGuid =
      this.globalService.getQueryParamInfo('AgentGuid') ||
      this.localCacheService.getSessionStorage('agentGuid');
    this.agentName =
      this.globalService.getQueryParamInfo('AgentName') ||
      this.localCacheService.getSessionStorage('agentName');
    if (this.agentName && agentGuid) {
      this.isPASUser = true;
    }
    this.partnerCode = this.pdsService.getWhiteLabelPartnerCode();
  }

  clearSession() {
    if (isPlatformBrowser(this.platformId)) {
      this.localCacheService.clearAllSession();
      location.href = this.PASUrl;
    }
  }
}
